"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.schemaConfiguracaoControleAcesso = exports.yupConfiguracaoControleAcesso = void 0;
const yup = __importStar(require("yup"));
exports.yupConfiguracaoControleAcesso = yup.object({
    diasCarencia: yup.number().notRequired().default(0).label('Dias de carência sobre cobranças'),
    valorMinimo: yup.number().notRequired().default(0).label('Valor devedor mínimo bloqueio'),
    bloquearInativos: yup.boolean().notRequired().default(false).label('Bloquear passagem de inativos'),
    modeloCatraca: yup.number().required().default(null).label('Modelo padrão das catracas'),
    minutosToleranciaAtrazo: yup.number().required().default(15).label('Minutos de tolerância a atrasos'),
    minutosLiberacaoCatracasEntrada: yup.number().notRequired().default(120).label('Minutos antes para aceitar Entrada'),
    minutosLiberacaoCatracasSaida: yup.number().notRequired().default(120).label('Minutos passados para aceitar saída'),
    definirPresencaEntrada: yup.boolean().notRequired().default(true).label('Gerar presenças na entrada'),
    bloquearForaHorario: yup.boolean().notRequired().default(false).label('Bloquear fora do horário'),
    versaoDeltaSGE: yup.number().notRequired().label('Versão do SGE2'),
    diretorioBancoDados: yup.string().notRequired().max(50).label('Banco de dados local'),
    tipoConexao: yup.number().notRequired().label('Tipo de conexão'),
    padraoCartao: yup.number().notRequired().label('Padrão para cartão'),
    porta: yup.number().notRequired().label('Porta padrão'),
    bancoDadosSGE3: yup.string().notRequired().label('Banco do SGE3'),
    sistemaIntegracao: yup.number().notRequired().label('Sistema de integração'),
    msgEntrada: yup.string().notRequired().label('Mensagem de entrada'),
    msgSaida: yup.string().notRequired().label('Mensagem de saída'),
    topDataOnline: yup.boolean().notRequired().default(true).label('Trabalhar online'),
    minIntervalo: yup.number().notRequired().default(0).label('minutos de intervalo'),
    apiOnline: yup.string().notRequired().max(256).label('API do online'),
    utilizaApi: yup.boolean().notRequired().default(false).label('Utilizar API'),
});
exports.schemaConfiguracaoControleAcesso = exports.yupConfiguracaoControleAcesso.shape({});
